export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Wysłano poprawnie",
      error: "Błąd wysyłki",
      notConfigured: "Nieskonfigurowane",
      pending: "Oczekuje na wysłanie",
    },
    errorNoInfo: "Błąd (brak szczegółów)",
  },
  msgPolice: {
    title: "Informacja",
    pendingSyncText:
      "Dane check-in oczekują na synchronizację; zostaną przesłane do lokalnych służb tego samego dnia, w którym gość przyjedzie do obiektu.",
    entryDateLabel: "Data przyjazdu:",
    syncedText:
      "Pomyślnie zsynchronizowano z lokalnymi służbami dane gościa: {name}.",
    syncDateLabel: "Data synchronizacji:",
    errorText:
      "Z przyczyn zewnętrznych nie udało się dokończyć synchronizacji z lokalnymi służbami.",
    close: "Zamknij",
  },
};
